import { render } from "./VideosCard.vue?vue&type=template&id=23377c3f"
import script from "./VideosCard.vue?vue&type=script&lang=js"
export * from "./VideosCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__